/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_Enum_Study_Economics_Education23Inputs */

const en__field_enum_study_economics_education23 = /** @type {(inputs: _Field_Enum_Study_Economics_Education23Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Economics Education`)
};

const de__field_enum_study_economics_education23 = /** @type {(inputs: _Field_Enum_Study_Economics_Education23Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wirtschaftspädagogik`)
};

/**
* | output |
* | --- |
* | "Economics Education" |
*
* @param {_Field_Enum_Study_Economics_Education23Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const _field_enum_study_economics_education23 = /** @type {((inputs?: _Field_Enum_Study_Economics_Education23Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_Enum_Study_Economics_Education23Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en__field_enum_study_economics_education23(inputs)
	return de__field_enum_study_economics_education23(inputs)
});
export { _field_enum_study_economics_education23 as "_field_enum_STUDY_ECONOMICS_EDUCATION" }